import { IInjectable, Ng2StateDeclaration, ResolveTypes } from '@uirouter/angular';
import { UserService } from '@fi-app/user/user.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { DataFieldService } from '@fi-app/data-field/data-field.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { UserEditNewLayoutComponent } from '@fi-app/user/user-edit/user-edit-new-layout/user-edit-new-layout.component';
import { ILightWeightObject } from '@fi-shared/models';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import {
    FiCoreUnitResolve_lightWeightBusinessUnits,
    FiCoreUserUnitResolve_accessRightFilterCollection,
} from '@fi-app/business-unit/states/resolve/access-right';

export const FiCoreAddUserStateResolveTypes: ResolveTypes[] | { [p: string]: IInjectable } = {
    user: [UserService, FiCoreAddUserStateResolve_user],
    availableBusinessUnits: FiCoreUnitResolve_lightWeightBusinessUnits,
    lightWeightBusinessUnits: ['user', 'availableBusinessUnits', FiCoreAddUserStateResolve_lightWeightBusinessUnits],
    lightWeightBusinessAreas: [
        'lightWeightBusinessUnits',
        BusinessAreaService,
        FiCoreAddUserStateResolve_lightWeightBusinessAreas,
    ],
    lightWeightRoles: ['user', 'accessRightFilterCollection', FiCoreAddUserStateResolve_lightWeightRoles],
    contentLanguages: [ContentLanguagesService, FiCoreAddUserStateResolve_contentLanguages],
    applicationLanguages: [ContentLanguagesService, FiCoreAddUserStateResolve_applicationLanguages],
    accessRightFilterCollection: FiCoreUserUnitResolve_accessRightFilterCollection,
    pageTitle: [PageTitleService, 'user', FiCoreAddUserStateResolve_pageTitle],
    userDataFields: ['user', DataFieldService, FiCoreAddUserStateResolve_userDataFields],
};

export const FiCoreAddUserStateV2: Ng2StateDeclaration = {
    name: FiStateNames.User.AddV2,
    url: '/AddV2',
    views: {
        '@': {
            component: UserEditNewLayoutComponent,
        },
    },
    resolve: FiCoreAddUserStateResolveTypes,
};

export function FiCoreAddUserStateResolve_user(userService: UserService) {
    return userService.getNewUserInstance();
}

/*
export function FiCoreAddUserStateResolve_userAvailableBusinessUnits(accessRightService: AccessRightService) {
    return accessRightService.GetBusinessUnitsForUserProfile();
}
*/

export function FiCoreAddUserStateResolve_lightWeightBusinessUnits(user, availableBusinessUnits) {
    let data = availableBusinessUnits.slice();
    user.BusinessUnits.forEach((businessUnit) => {
        if (!data.find((item) => item.Id === businessUnit.Id)) {
            data.push(businessUnit);
        }
    });

    return data;
}

export function FiCoreAddUserStateResolve_lightWeightBusinessAreas(
    lightWeightBusinessUnits: ILightWeightObject[],
    businessAreaService: BusinessAreaService,
) {
    return businessAreaService.GetBusinessAreasByBusinessUnitIds(lightWeightBusinessUnits.map((item) => item.Id));
}

export function FiCoreAddUserStateResolve_lightWeightRoles(user, accessRightFilterCollection) {
    const data = accessRightFilterCollection.AccessRightCoreFilter.Roles.slice();

    user.Roles.forEach((role) => {
        // if user role is not already in the list then add it
        if (accessRightFilterCollection.AccessRightCoreFilter.RoleIds.indexOf(role.Id) < 0) {
            data.push(role);
        }
    });

    return data;
}

export function FiCoreAddUserStateResolve_contentLanguages(contentLanguagesService: ContentLanguagesService) {
    return contentLanguagesService.GetContentLanguages();
}

export function FiCoreAddUserStateResolve_applicationLanguages(contentLanguagesService: ContentLanguagesService) {
    return contentLanguagesService.GetApplicationLanguages();
}

export function FiCoreAddUserStateResolve_pageTitle(ccmPageTitle: PageTitleService, user) {
    return ccmPageTitle.setTitleByItem(user);
}

export function FiCoreAddUserStateResolve_userDataFields(user, dataFieldService: DataFieldService) {
    return dataFieldService.getUserFields(user.Id);
}
